import { NotificationModal } from "src/models/pages/notificationModal";
import { NotificationTypes } from "./actionTypes";

const initialState: NotificationModal = {
  error: "",
  loading: false,
  message: "",
  paginatorCount: 0,
  notificationList: [],
  totalRecords: 0,
  notificationDetails:"",
  statusList:[],
  notification:[],
  notificationClose:"",
  notificationConfig:"",
  notificationCount:0
};



const Notification = (state = initialState, action: any) => {
  switch (action.type) {
    case NotificationTypes.GET_NOTIFICATION_LIST_LOADING:
    case NotificationTypes.GET_BY_ID_NOTIFICATION_LOADING:
    case NotificationTypes.GET_NOTIFICATION_CONFIG_LOADING:
    case NotificationTypes.POST_NOTIFICATION_CONFIG_LOADING:
      return {
        ...state,
        loading: true,
        paginatorCount: 0,
        message: "",
        error: ""
      };
    case NotificationTypes.GET_NOTIFICATION_LOADING:
      return {
        ...state,
        notificationClose:""
      };


    case NotificationTypes.GET_NOTIFICATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        notificationList:action.payload.data.items,
        totalRecords : action.payload.data.totalCount,
        paginatorCount:action.payload.data.items.length
      };
    case NotificationTypes.GET_BY_ID_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        notificationDetails:action.payload.data,
      };
   
    case NotificationTypes.GET_NOTIFICATION_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        statusList:action.payload.data
      };
   
    case NotificationTypes.GET_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        notification:action.payload.data
      };
   
    case NotificationTypes.GET_NOTIFICATION_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        notificationCount:action.payload.data
      };
   
    case NotificationTypes.CLOSE_NOTIFICATION_SUCCESS:
      debugger
      return {
        ...state,
        loading: false,
        notificationClose:"Notification Closed"
      };
   
    case NotificationTypes.CLOSE_ALL_NOTIFICATION_SUCCESS:
      debugger
      return {
        ...state,
        loading: false,
        notificationClose:"All Notification Closed"
      };
    
    case NotificationTypes.CLEAR_NOTIFICATION_MESSAGE:
      return {
        ...state,
        loading: false,
        error:"",
        message:""
      };
    
    case NotificationTypes.GET_NOTIFICATION_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        notificationConfig:action.payload.data
      };
    case NotificationTypes.POST_NOTIFICATION_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        message:"Notification config updated successfully"
      };
    case NotificationTypes.CLEAR_NOTIFICATION_CONFIG:
      return {
        ...state,
        loading: false,
        message:"",
        error:"",
      };

    case NotificationTypes.GET_NOTIFICATION_LIST_ERROR:
    case NotificationTypes.GET_BY_ID_NOTIFICATION_ERROR:
    case NotificationTypes.GET_NOTIFICATION_STATUS_ERROR:
    case NotificationTypes.GET_NOTIFICATION_CONFIG_ERROR:
    case NotificationTypes.POST_NOTIFICATION_CONFIG_ERROR:
    case NotificationTypes.GET_NOTIFICATION_COUNT_ERROR:

      return {
        ...state,
        loading: false,
        error: action.payload
      };


    default:
      return { ...state };
  }
};

export default Notification;
